﻿/*
 * Globalize Culture cs-CZ
 *
 * http://github.com/jquery/globalize
 *
 * Copyright Software Freedom Conservancy, Inc.
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * This file was generated by the Globalize Culture Generator
 * Translation: bugs found in this file need to be fixed in the generator
 */

(function(window, undefined) {
  var Globalize;

  if (
    typeof require !== "undefined" &&
    typeof exports !== "undefined" &&
    typeof module !== "undefined"
  ) {
    // Assume CommonJS
    Globalize = require("globalize");
  } else {
    // Global variable
    Globalize = window.Globalize;
  }

  Globalize.addCultureInfo("cs-CZ", "default", {
    name: "cs-CZ",
    englishName: "Czech (Czech Republic)",
    nativeName: "čeština (Česká republika)",
    language: "cs",
    numberFormat: {
      ",": " ",
      ".": ",",
      NaN: "Není číslo",
      negativeInfinity: "-nekonečno",
      positiveInfinity: "+nekonečno",
      percent: {
        pattern: ["-n%", "n%"],
        ",": " ",
        ".": ","
      },
      currency: {
        pattern: ["-n $", "n $"],
        ",": " ",
        ".": ",",
        symbol: "Kč"
      }
    },
    calendars: {
      standard: {
        "/": ".",
        firstDay: 1,
        days: {
          names: [
            "neděle",
            "pondělí",
            "úterý",
            "středa",
            "čtvrtek",
            "pátek",
            "sobota"
          ],
          namesAbbr: ["ne", "po", "út", "st", "čt", "pá", "so"],
          namesShort: ["ne", "po", "út", "st", "čt", "pá", "so"]
        },
        months: {
          names: [
            "leden",
            "únor",
            "březen",
            "duben",
            "květen",
            "červen",
            "červenec",
            "srpen",
            "září",
            "říjen",
            "listopad",
            "prosinec",
            ""
          ],
          namesAbbr: [
            "1",
            "2",
            "3",
            "4",
            "5",
            "6",
            "7",
            "8",
            "9",
            "10",
            "11",
            "12",
            ""
          ]
        },
        monthsGenitive: {
          names: [
            "ledna",
            "února",
            "března",
            "dubna",
            "května",
            "června",
            "července",
            "srpna",
            "září",
            "října",
            "listopadu",
            "prosince",
            ""
          ],
          namesAbbr: [
            "1",
            "2",
            "3",
            "4",
            "5",
            "6",
            "7",
            "8",
            "9",
            "10",
            "11",
            "12",
            ""
          ]
        },
        AM: ["dop.", "dop.", "DOP."],
        PM: ["odp.", "odp.", "ODP."],
        eras: [{ name: "n. l.", start: null, offset: 0 }],
        patterns: {
          d: "d.M.yyyy",
          D: "d. MMMM yyyy",
          t: "H:mm",
          T: "H:mm:ss",
          f: "d. MMMM yyyy H:mm",
          F: "d. MMMM yyyy H:mm:ss",
          M: "dd MMMM",
          Y: "MMMM yyyy"
        }
      }
    },
    messages: {
      AdditionalHelp: "Další nápověda",
      AddNewTab: "Přidat novou kartu",
      Alerts: "Upozornění",
      ApplyFilter: "Použít filtr",
      Approve: "Schválit",
      Attachments: "Přílohy",
      Back: "Zpět",
      Basic: "Základní",
      Between: "Mezi",
      Book: "Kniha",
      Cancel: "Storno",
      Checked: "Zaškrtnuto",
      ClearFilter: "Vymazat filtr",
      Close: "Zavřít",
      CloseCancelChanges: "Zavřít a zrušit změny",
      CloseSaveChanges: "Zavřít a uložit změny",
      CloseTab: "Zavřít kartu",
      ColumnPersonalization: "Přizpůsobení sloupce",
      Comments: "Komentáře",
      Confirmation: "Potvrzení",
      Contains: "Obsahuje",
      CreateTab: "Vytvořit novou kartu",
      Cut: "Vyjmout",
      Delete: "Odstranit",
      DiscardUndo: "Zrušit/Vrátit zpět",
      DisplayDropDownList: "Zobrazit rozbalovací seznam",
      Displaying: "Zobrazeno: ",
      DocWord: "Dokument",
      DoesNotContain: "Neobsahuje",
      DoesNotEndWith: "Nekončí na",
      DoesNotEqual: "Nerovná se",
      DoesNotStartWith: "Nezačíná na",
      Download: "Stáhnout",
      Duplicate: "Duplikovat",
      Edit: "Upravit",
      EitherSelectedorNotSelected: "Buďto vybráno nebo nevybráno",
      Email: "E-mail",
      EndsWith: "Končí na",
      EqualsStr: "Rovná se",
      ExpandCollapse: "Rozbalit/Sbalit",
      ExportFailed: "Export se nezdařil",
      ExportToExcel: "Export do Excelu",
      FileInUse: "Určený soubor se používá",
      FileInUseDetail:
        "Zavřete soubor v aplikaci, která jej používá, nebo zadejte jiný název souboru.",
      Filter: "Filtr",
      FilterMenu: "Filtrovat nabídku",
      FilterOptions: "Filtrovat možnosti",
      FilterWithinResults: "Filtrovat výsledky",
      First: "První",
      FirstView: "První zobrazení",
      Folder: "Složka",
      ForgotPassword: "Zapomněli jste heslo?",
      Forward: "Vpřed",
      GetMoreRows: "Získat další řádky",
      GreaterThan: "Větší než",
      GreaterThanOrEquals: "Větší než nebo rovno",
      GridSettings: "Nastavení mřížky",
      GroupSelection: "Skupinový výběr",
      Help: "Nápověda",
      HideColumn: "Skrýt sloupec",
      IsEmpty: "Je prázdný",
      IsNotEmpty: "Není prázdný",
      Last: "Poslední",
      LastView: "Poslední zobrazení",
      LaunchActivate: "Spustit/Aktivovat",
      LessThan: "Menší než",
      LessThanOrEquals: "Menší než nebo rovno",
      Links: "Odkazy",
      ListTabs: "Vypsat všechny karty",
      LoadingItem: "Načítání položky ",
      Maintenance: "Údržba",
      Menu: "Nabídka",
      New: "Nový",
      Next: "Následující",
      NextView: "Následující zobrazení",
      No: "Ne",
      NotChecked: "Nezaškrtnuto",
      Notes: "Poznámky",
      NotSelected: "Nevybráno",
      Of: " z ",
      Ok: "OK",
      Open: "Otevřít",
      Password: "Heslo",
      Paste: "Vložit",
      Phone: "Telefon",
      PleaseWait: "Prosím čekejte",
      Previous: "Předchozí",
      PreviousView: "Předchozí zobrazení",
      Print: "Tisk",
      Queries: "Dotazy",
      Redo: "Opakovat",
      Refresh: "Aktualizovat",
      Reject: "Odmítnout",
      RememberMe: "Zapamatovat si mě na tomto počítači",
      Reports: "Sestavy",
      Reset: "Reset",
      Review: "Revidovat",
      RunFilter: "Spustit filtr",
      RunJob: "Spustit úlohu",
      Save: "Uložit",
      SaveBeforeClosing: "Uložit před zavřením",
      SavedFilters: "Uložené filtry",
      SaveSubmit: "Uložit/Odeslat",
      ScreenDesign: "Uspořádání obrazovky",
      Search: "Vyhledat",
      SelectContents: "Vybrat obsah",
      SelectDate: "Vybrat datum",
      SelectDeselect: "Vybrat vše / Zrušit výběr všeho",
      Selected: "Vybráno: ",
      ServerName: "Název serveru",
      Settings: "Nastavení",
      ShowFilterRow: "Zobrazit řádek filtru",
      SignIn: "Přihlásit se",
      SortAscending: "Řadit vzestupně",
      SortDescending: "Řadit sestupně",
      Spreadsheet: "Tabulka",
      StartsWith: "Začíná na",
      StatusIndicator: "Indikátor stavu",
      Tasks: "Úlohy",
      Today: "Dnes",
      Translate: "Přeložit",
      UserID: "ID uživatele",
      Utilities: "Nástroje",
      Yes: "Ano",
      Page: "Stránka",
      Rows: "Řádky",
      ShowingAll: "Zobrazeno vše",
      SessionNavigation: "Navigace relací",
      ListAllMenuItems: "Vypsat všechny položky nabídky",
      NoRecordsFound: "Nebyly nalezeny žádné záznamy",
      SearchTree: "Prohledat strom",
      Clear: "Vymazat",
      DrillDown: "Procházet hierarchii",
      Required: "Toto pole je vyžadováno",
      Available: "K dispozici:",
      Add: "Přidat",
      MoveDown: "Přesunout dolů",
      MoveUp: "Přesunout nahoru",
      Remove: "Odebrat",
      LastYear: "Minulý rok",
      NextMonth: "Příští měsíc",
      NextWeek: "Příští týden",
      NextYear: "Příští rok",
      OneMonthAgo: "Před měsícem",
      OneWeekAgo: "Před týdnem",
      SixMonthsAgo: "Před půl rokem",
      Time: "Čas",
      CannotBeSelected: "Tento řádek nelze vybrat.",
      ResetToDefault: "Obnovit výchozí uspořádání",
      CloseOtherTabs: "Zavřít ostatní karty",
      EmailValidation: "Zadejte platnou e-mailovou adresu",
      UrlValidation: "Zadejte platné URL",
      EndofResults: "Konec výsledků",
      More: "Další...",
      RecordsPerPage: "Záznamů na stránku",
      Maximize: "maximalizovat",
      Minimize: "minimalizovat",
      Loading: "Načítání..."
    }
  });
})(this);
